import companiesApi from '@/api/admin/companies'
import { getContainerGroupsForCompany } from '@/api/admin/container_groups'
import { getContainersForCompany } from '@/api/admin/containers'
import { downloadProjectStatsCsv, getProject, getProjectsForCompany } from '@/api/admin/projects'
import { createUser, deleteUser, getUser, getUsers, updateUser } from '@/api/admin/users'

const adminsApi = {
  createUser,
  companies: companiesApi,
  deleteUser,
  downloadProjectStatsCsv,
  getContainerGroupsForCompany,
  getContainersForCompany,
  getProject,
  getProjectsForCompany,
  getUser,
  getUsers,
  updateUser,
}

export default adminsApi
